import { setupConfig } from "@ionic/core";
import "@ionic/pwa-elements";
// tslint:disable-next-line: no-duplicate-imports
import "jeep-sqlite";
import { defineCustomElements as jeepSqlite } from "jeep-sqlite/loader";
import { setAccessToken, setWorkerUrl } from 'mapbox-gl/esm';

import { CONFIGS } from "../config";
import { initExpressionRuntime } from "../services/expressionRuntime/initExpressionRuntime";
import { initSentry } from "../services/sentry.service";

setAccessToken(CONFIGS.prod.MAPBOX_TOKEN);
setWorkerUrl(new URL('assets/mapbox/worker.js', document.baseURI || window.location.href).href);

export default async () => {
  /**
   * The code to be executed should be placed within a default function that is
   * exported by the global script. Ensure all of the code in the global script
   * is wrapped in the function() that is exported.
   */

  setupConfig({
    mode: "ios",
    spinner: "crescent",
    swipeBackEnabled: false,
    innerHTMLTemplatesEnabled: true,
  });

  // Initialize Sentry as early as possible
  initSentry();

  await initExpressionRuntime();
};

setTimeout(() => jeepSqlite(window));
